import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function CreateOrder (){
  const {user} = useUser()
  let view = contentLayout[modules.CreateOrder]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CreateOrder.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CreateOrder}></Index>
 )
}

export default CreateOrder
